import { Text, VStack } from '@chakra-ui/react';

import { LDFlags } from '../../../../../../constants/flags';
import { useLienholderTrackRecordQuery } from '../../../../../../gql/generated/graphql';
import { useFlag } from '../../../../../../hooks';
import CompetitorTruthLine from './CompetitorTruthLine';

const MIN_LIENHOLDER_COUNT = 500;

const formatRoundedDownCount = (count: number, unit: number): string =>
  `${(Math.floor(count / unit) * unit).toLocaleString('en-US')}+`;

const formatAllTimeCount = (count: number): string =>
  formatRoundedDownCount(count, count < 1000 ? 100 : 1000);

type TrustStripProps = {
  lienholderSlug: string | null;
  lienholderName: string | null;
  dealId: string;
  leadId: string;
  showDivider: boolean;
};

const TrustStrip = ({
  lienholderSlug,
  lienholderName,
  dealId,
  leadId,
  showDivider,
}: TrustStripProps) => {
  const sellerConfidenceEnabled = useFlag(LDFlags.MARKETPLACE_SELLER_CONFIDENCE);
  const { data } = useLienholderTrackRecordQuery({
    variables: { lienholderSlug },
    skip: !sellerConfidenceEnabled,
  });
  const trackRecord = data?.lienholderTrackRecord;
  if (!sellerConfidenceEnabled || trackRecord?.allTimeFundedCount == null) return null;

  const { lienholderFundedCount, allTimeFundedCount } = trackRecord;
  const lienholderLabel =
    lienholderName != null &&
    lienholderFundedCount != null &&
    lienholderFundedCount >= MIN_LIENHOLDER_COUNT
      ? `${formatRoundedDownCount(lienholderFundedCount, 100)} ${lienholderName}`
      : null;

  return (
    <VStack
      spacing={0}
      w="100%"
      maxW="620px"
      pt={showDivider ? '16px' : 0}
      borderTopWidth={showDivider ? '1px' : 0}
      borderColor="grayLightest"
      textAlign="center"
    >
      <Text fontSize={{ base: '12px', md: '13px' }} fontWeight="600" color="charcoal">
        We've ended <Text as="b">{lienholderLabel ?? formatAllTimeCount(allTimeFundedCount)}</Text>{' '}
        leases. We know every step of {lienholderLabel != null ? 'their' : 'the'} process.
      </Text>
      <CompetitorTruthLine
        lienholderSlug={lienholderSlug}
        lienholderName={lienholderName}
        dealId={dealId}
        leadId={leadId}
      />
    </VStack>
  );
};

export default TrustStrip;
